import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FbCoreModule } from '@fleet-beat/core';
import { InfiniteListComponent } from './components/infinite-list.component';
import { InfiniteListScrollDirective } from './derectives/infinite-list-scroll.directive';
import { InfiniteListItemWidthPipe } from './pipes/infinite-list-item-width.pipe';

@NgModule({
  imports: [
    FbCoreModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatProgressBarModule,
    FlexModule,
    FlexLayoutModule,
    MatIconModule,
  ],
  declarations: [InfiniteListComponent, InfiniteListScrollDirective, InfiniteListItemWidthPipe],
  exports: [InfiniteListComponent, InfiniteListScrollDirective],
})
export class InfiniteListModule {}
